const clauseCardDesc = [
  {
    type: "description",
    category: [`Single Family`, `fsbo`, `mere`],
    text: `<p>
    The majority of clauses can be found within the
    <a
      href="https://albertarealtor.ca/forms#form-resources"
      target="_blank"
      rel="noopener noreferrer"
    >
      AREA Conditions/Terms Booklet</a>. Review the booklet to become familiar with the clauses available to
    you. The AREA Conditions/Terms Booklet contains alternate versions of some of the clauses listed
    below, which may better suit your clients needs.
    <br />
    <br />
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your clients
    best interests. Any custom clause(s) should be written by your clients
    lawyer.
  </p>`,
  },
  {
    type: "description",
    category: `assign`,
    text: `<p>
    Since assignments involve the purchasing of an Agreement of Purchase & Sale, 
    it is important to review the Original Contract to understand the terms & 
    conditions relating to the agreement that is for sale. Advise your client to 
    choose a lawyer well-versed in assignments, as these deals tend to be more 
    complex compared to other transaction types.     Refer to the <a
    href="https://albertarealtor.ca/forms#form-resources"
    target="_blank"
    rel="noopener noreferrer"
  >
    AREA Conditions/Terms Booklet</a> for additional clauses that may apply.<br/>
    <br />
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your clients
    best interests. Any custom clause(s) should be written by your clients
    lawyer. 
  </p>`,
  },
  {
    type: "description",
    category: `precon`,
    text: `<p>
    In pre-construction purchases, the majority of agreements will use the 
    Builder's Forms. It is essential to thoroughly read and understand the terms 
    of the agreement, particularly the clauses.
    <br /><br/>
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your clients
    best interests. Any custom clause(s) should be written by your clients
    lawyer.<br/><br/>
    <p>Important clauses/terms to watch for are: </p>
    <ol>
    <li>Lawyer Review Clause</li>
    <li>Financing Clause</li>
    <li>Restrictions Relating to Assignments & Leasing</li>
    <li>Occupancy & Construction Delay Related Clauses</li>
    <li>Termination of Agreement Clauses</li>
    <li>Adjustments on Closing</li>
    </ol>
  </p>`,
  },
  {
    type: "description",
    category: [`lease`, `landlordSRP`, `leaseMere`],
    text: `<p>
    The majority of clauses can be found within the
    <a
      href="https://albertarealtor.ca/forms#form-resources"
      target="_blank"
      rel="noopener noreferrer"
    >
      AREA Conditions/Terms Booklet</a>. Review the booklet to become familiar with the clauses available to
    you. The Shortcodes (example: LEASE/RES-1) are how you locate the clauses
    within the AREA Conditions/Terms Booklet or your Forms Platform. 
    <br/><br/>In order to serve your clients best interests, you should be familiar 
    with the <a
    href="https://www.ontario.ca/laws/statute/06r17"
    target="_blank"
    rel="noopener noreferrer"
  >Residential Tenancies Act (RTA)</a>. Illegal clauses, meaning 
    those that contravene the RTA, should not be included in 
    the agreement. Any clause in a lease agreement that contradicts the RTA is void.
    <br />
    <br />
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your clients
    best interests. Any custom clause(s) should be written by your clients
    lawyer. 
  </p>`,
  },
];

export default clauseCardDesc;
